import { isDefined } from "@clipboard-health/util-ts";

import { DocumentDetailsSection } from "./DetailsSection";
import { useRequirementDetailsContext } from "./useRequirementDetailsContext";

export function DocumentDetailsInstructions() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const { requirement } = workerRequirement;
  const { instructions } = requirement?.attributes ?? {};

  if (!isDefined(instructions)) {
    return null;
  }

  return <DocumentDetailsSection title="Instructions" description={instructions} />;
}
